import styled from 'styled-components';
import theme from 'styles/theme';

export const DropdownBadgeStyled = styled.div`
  text-transform: lowercase;
  font-size: 12px;
  font-weight: 600;
  border-radius: 10px;
  padding: 0px 6px;
  margin-left: 8px;

  height: 20px;

  background-color: ${theme.colors.primaryBlue};
  color: white;
`;
